import _property from 'lodash/property';
import { COUPON_DATA_FIELD_NAMES } from '../constants/coupons';

var id = _property(COUPON_DATA_FIELD_NAMES.ID);

var appliedOn = _property(COUPON_DATA_FIELD_NAMES.APPLIED_ON);

var couponCode = _property(COUPON_DATA_FIELD_NAMES.COUPON_CODE);

var description = _property(COUPON_DATA_FIELD_NAMES.DESCRIPTION);

var taxExempted = _property(COUPON_DATA_FIELD_NAMES.TAX_EXEMPTED);

var taxable = _property(COUPON_DATA_FIELD_NAMES.TAXABLE);

var isROLevelCoupon = _property(COUPON_DATA_FIELD_NAMES.RO_LEVEL_ONLY);

var payTypes = _property(COUPON_DATA_FIELD_NAMES.PAYTYPES);

var pricingDetail = _property(COUPON_DATA_FIELD_NAMES.PRICING_DETAIL);

var departments = _property(COUPON_DATA_FIELD_NAMES.DEPARTMENTS);

var name = function name(coupon) {
  if (description(coupon)) {
    return "".concat(couponCode(coupon), " - ").concat(description(coupon));
  }

  return couponCode(coupon);
};

export default {
  id: id,
  name: name,
  payTypes: payTypes,
  appliedOn: appliedOn,
  couponCode: couponCode,
  description: description,
  taxExempted: taxExempted,
  isROLevelCoupon: isROLevelCoupon,
  pricingDetail: pricingDetail,
  taxable: taxable,
  departments: departments
};